import { render, staticRenderFns } from "./CalendarBorderPadding.vue?vue&type=template&id=7ace8de2"
import script from "./CalendarBorderPadding.vue?vue&type=script&lang=js"
export * from "./CalendarBorderPadding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports